import React, { Component } from 'react';
import { Form, withFormik } from 'formik';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import includes from 'lodash/includes';
import { Checkbox, Input } from '../../Form/';
import './LanguagesKnowledgeCard.css';

class LanguagesKnowledgeCard extends Component {
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.values, this.props.values)) {
      this.send();
    }
  }

  send = debounce(() => {
    const { values, errors } = this.props;
    this.props.handleInputChange({ values, errors });
  }, 300);

  render() {
    const cbClass = 'languages-knowledge-card__form-checkbox';
    const cbName = 'fluent_languages';

    const { values } = this.props;

    const hasOther = includes(values.fluent_languages, 'Other');
    return (
      <div className="col-12 col-lg-7 mx-auto">
        <Form className="bg-white shadow-card p-5 row">
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="English" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Arabic" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Azerbaijani" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="German" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Spanish" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="French" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Bahasa" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Italian" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Japanese" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Korean" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Dutch" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Polish" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Portuguese" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Russian" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Swedish" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Ukranián" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Chinese" />
          </div>
          <div className="col-6">
            <Checkbox className={cbClass} name={cbName} value="Other" />
          </div>

          {hasOther && (
            <Input
              inputClassName="languages-knowledge-card__form-checkbox"
              name="other_languages"
              fluid
            />
          )}
        </Form>
      </div>
    );
  }
}

LanguagesKnowledgeCard.propTypes = {
  errors: PropTypes.object,
  handleInputChange: PropTypes.func,
  values: PropTypes.shape({
    fluent_languages: PropTypes.array,
  }),
};

export default withFormik({
  validateOnBlur: true,
  validateOnChange: true,
  displayName: 'LanguagesKnowledgeCardForm',
})(LanguagesKnowledgeCard);



// WEBPACK FOOTER //
// ./src/components/FreelancerPortfolio/LanguagesKnowledgeCard/LanguagesKnowledgeCard.js